<div class="cart-products-widget-container">
  <div class="cart-products-widget-products">
    <div
      *ngIf="scrollableElement && products.length > 0"
      class="scroll-arrow"
      style="position: absolute; top: 40%; right: 0"
      (click)="scrollRight()"
    >
      <a><i class="far fa-arrow-circle-right"></i></a>
    </div>
    <div
      *ngIf="
        scrollableElement &&
        scrollableElement.scrollLeft > 0 &&
        products.length > 0
      "
      class="scroll-arrow"
      style="position: absolute; top: 40%"
      (click)="scrollLeft()"
    >
      <a> <i class="far fa-arrow-circle-left"></i></a>
    </div>
    <app-cart-products
      *ngIf="shoppingCartConfigs"
      [products]="products"
      [isTable]="false"
      [productsLoading]="false"
      [config]="shoppingCartConfigs"
      [CardCode]=""
      [customer]=""
      [forceEnableQtyInputs]="true"
      (onProductQuantityChanged)="onProductQuantityChanged($event)"
      (onProductWarehouseChanged)="onProductWarehouseChanged($event)"
    ></app-cart-products>
  </div>
</div>
